import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Compass.svg",
  "use": "Compass.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Compass.svg\"><path d=\"M32.01,56.0208a24,24,0,1,1,24-24A24,24,0,0,1,32.01,56.0208Zm12.102-37.8069-14.724,9.8275a4.85,4.85,0,0,0-1.3451,1.3467L18.227,44.1292a1.2132,1.2132,0,0,0,1.6814,1.6833L34.6325,35.985a4.8525,4.8525,0,0,0,1.3451-1.3467l9.8162-14.741A1.2133,1.2133,0,0,0,44.1123,18.2139ZM32.01,35.0208a3,3,0,1,1,3-3A3,3,0,0,1,32.01,35.0208Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol